import { render, staticRenderFns } from "./CsvIcon.vue?vue&type=template&id=edf3de0e&"
import script from "./CsvIcon.vue?vue&type=script&lang=js&"
export * from "./CsvIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports